module.exports = __webpack_public_path__ + "static/numbers-56bc2c00825956f20fa3774cb596d103.svg";